<section class="sx-dialog__small">
  <header class="sx-dialog__content">
    <h2 class="sx-dialog__heading h3">{{data.header}}</h2>
  </header>
  <div class="sx-dialog__content-small" [innerHTML]="data.message | safeHtml">
  </div>
  <div class="sxh-button-footer sxl-align-right sxl-horizontal-stack-small">
    <button class="sx-button sx-button--white" mat-button [mat-dialog-close]="false" id="confirm_cancel_btn">{{ 'core.button.cancel' | translate }}</button>
    <button class="sx-button sx-button--magenta" mat-button [mat-dialog-close]="true" id="confirm_ok_btn"> {{data.confirmButtonText}}</button>
  </div>
</section>
